import * as React from 'react';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { useCartSettings } from '../CartSettings/context.js';
import '@swc/helpers';
import { useGetCart } from '../../hooks/use-get-cart.js';
import '../../models/add-to-cart/add-to-cart.js';
import '../../models/cart/cart.js';
import '../../models/subscription/subscription-details.js';
import { CheckoutState } from '../../models/checkoutState/checkoutState.js';
import { CartContext } from './context.js';

const CartProvider = ({ children  })=>{
    const { cartId , cartHash  } = useCartSettings();
    const [cart, { setData  }] = useCartStorage();
    const isNewCart = React.useMemo(()=>cart.cartId !== cartId
    , [
        cart.cartId,
        cartId
    ]);
    const handleCartState = React.useCallback(()=>{
        if (cartId && cartHash && cart.cartId !== cartId) {
            setData({
                cartId,
                cartHash,
                cartCount: cart.cartCount
            });
        }
    }, [
        cartHash,
        cartId,
        cart.cartId,
        setData,
        cart.cartCount
    ]);
    React.useEffect(()=>{
        if (isNewCart) {
            handleCartState();
        }
    }, [
        handleCartState,
        isNewCart
    ]);
    const { called , refetch , loading , data , error , fetchByCartId , reset  } = useGetCart();
    const isFinalized = (data === null || data === void 0 ? void 0 : data.checkoutState) === CheckoutState.Finalized;
    React.useEffect(()=>{
        if (isFinalized) {
            reset();
        }
    // removed recover cart from dep to eliminate unnecessary run
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFinalized
    ]);
    const value = React.useMemo(()=>({
            cart: data,
            refetch,
            loading,
            error,
            called,
            fetchByCartId
        })
    , [
        data,
        refetch,
        called,
        loading,
        error,
        fetchByCartId
    ]);
    if (typeof children === 'function') {
        return /*#__PURE__*/ React.createElement(CartContext.Provider, {
            value: value
        }, children(value));
    }
    return /*#__PURE__*/ React.createElement(CartContext.Provider, {
        value: value
    }, children);
};

export { CartProvider };
//# sourceMappingURL=provider.js.map
